import React, { useState } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import * as Sentry from '@sentry/react';

const ErrorBoundary = ({
    children,
    FallbackComponent,
    maxReloads = 3,
    canReload = true,
}: {
    children: React.ReactNode;
    FallbackComponent?: React.ComponentType<{
        onReload: () => void;
        canReload: boolean;
    }> | null;
    maxReloads?: number;
    canReload?: boolean;
}) => {
    const [retries, setRetries] = useState(0);

    const onReload = () => {
        setRetries(prev => prev + 1);
    };

    const handleError = (error, errorInfo) => {
        //eslint-disable-next-line no-console
        console.error(error);
        //eslint-disable-next-line no-console
        console.error(errorInfo);

        Sentry.withScope(scope => {
            scope.setExtras(errorInfo);
            Sentry.captureException(error);
        });
    };

    const _canReload = retries < maxReloads && canReload;

    return (
        <ReactErrorBoundary
            FallbackComponent={() => {
                if (!FallbackComponent) return null;
                return (
                    <FallbackComponent
                        onReload={onReload}
                        canReload={_canReload}
                    />
                );
            }}
            onError={handleError}
            resetKeys={[retries]}
        >
            {children}
        </ReactErrorBoundary>
    );
};

export default ErrorBoundary;
